"use strict"

// presicion is key stack
var digitsStack = [];

module.exports.add = function(value) {
  if (value === null) return 0; // just ignore null values from algorithm
  if (digitsStack.length === 0) { digitsStack.push(value); return digitsStack.length }
  if ((value - digitsStack[digitsStack.length - 1] === 1)) {
    digitsStack.push(value);
  } else if (value !== digitsStack[digitsStack.length - 1]) {
    digitsStack = [value];
  } // else means that values are same -> no need to do anything


  // just for sure, limit stack size to 100
  if (digitsStack.length > 100) {
    digitsStack.shift();
  }
  return digitsStack.length;
}


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/digits/digits-stack.js
// module id = 842
// module chunks = 0